import React from "react";
import { Label } from "../../../../../../library/label";

const Index = ({ role, index, arr }) => {
  return (
    <tr className={index === arr.length - 1 ? "bottom" : ""}>
      <td>
        <Label version={1} weight="bold">
          {role && role.name ? role.name : "Ikke tilgjengelig"}
        </Label>
      </td>
      <td>
        <Label version={2} weight="regular">
          {role && role.role ? role.role : "Ikke tilgjengelig"}
        </Label>
      </td>
      <td>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={`https://www.linkedin.com/search/results/all/?keywords=${encodeURIComponent(
            role.name
          )}`}
        >
          <button>
            <i className="fab fa-linkedin-in"></i>
          </button>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://www.1881.no/?query=${encodeURIComponent(role.name)}`}
        >
          <button>
            <i className="fas fa-phone"></i>
          </button>
        </a>
      </td>
    </tr>
  );
};

export default Index;
